const ROOT = process.env.REACT_APP_API_GRAPHQL;
const imageLinksFooterRoute =
  ROOT +
  "?query={redesSociales(status: PUBLISHED){titulo bag{contentItems{... on RedSocial{displayText imagen{urls} nombre uRL{text url}}}}} logoFooter(status: PUBLISHED){logo{urls}} saladePrensa(status: PUBLISHED){titulo logoPrensa{urls} logoPrensaLink{text url} logoWhatsapp{urls} logoWhatsappLink{text url}}}";
const textLinksFooterRoute =
  ROOT +
  "?query={footerLeftLinks(status: PUBLISHED){ahorroyCredito{text url} seguros{text url} sobreelGrupoCS{text url}} footerCenterLinks(status: PUBLISHED){mapadelSitio{text url} novaHub{text url}} footerRightLinks(status: PUBLISHED){correoGeneral{text url} mapadeSucursales{text url} privacidadyUsodeDatos{text url}}}";
const logoSitioWebRoute =
  ROOT + "?query={aCLogoUnaSolaTinta(status: PUBLISHED){logo{urls}}}";
const footerRoute = { imageLinksFooterRoute, textLinksFooterRoute, logoSitioWebRoute };

export default footerRoute;
